import { InjectionToken } from '@angular/core';
import { Action, ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { LocalDB } from './local-db';
import { StoreAction, XmAction } from './actions';
import { paymentSummaryReducer } from './payment-summary/reducer';
import {
    cms5GPlanOverviewReducer,
    cmsABTestReducer,
    cmsAccountDataPlanCollectionReducer,
    cmsActivationReducer,
    cmsActivityReducer,
    cmsAdditionalDevicePaymentReducer,
    cmsAddonDetailsReducer,
    cmsAddonErrorsReducer,
    cmsAddonPlansReducer,
    cmsAgentQuickpayReducer,
    cmsBillingAdpReducer,
    cmsBillingCreditReducer,
    cmsBillingExchangeInstructionReducer,
    cmsBillingLandingReducer,
    cmsBillingPaymentReducer,
    cmsBillingStatementReducer,
    cmsBucketSwitchReducer,
    cmsByodExchangeReducer,
    cmsCallFromUSReducer,
    cmsCompatibilityCheckReducer,
    cmsContactBarReducer,
    cmsCoreReducer,
    cmsCountryCodingMappingReducer,
    cmsDataDetailReducer,
    cmsDataSaverReducer,
    cmsDeviceCancelReducer,
    cmsDeviceEsimDownloadReducer,
    cmsDevicePasscodeReducer,
    cmsDeviceReturnReducer,
    cmsDevicesReducer,
    cmsDeviceSuspendReducer,
    cmsDeviceUpgradeReducer,
    cmsE911AddressReducer,
    cmsErrorsReducer,
    cmsEsimActivationReducer,
    CmsEsimReducer,
    cmsExchangeOrderReducer,
    cmsExtendedPromosReducer,
    cmsHopReducer,
    cmsInternationalCallingReducer,
    cmsInternationalReducer,
    cmsInternationalTravelReducer,
    cmsLevelMoveEligibilityReducer,
    cmsLevelMoveErrorReducer,
    cmsLevelMoveInProgressReducer,
    cmsLevelMovePendingReducer,
    cmsLevelMoveStartReducer,
    cmsLevelMoveSuccessReducer,
    cmsLineDataPlanCollectionReducer,
    CmsLineTransferReducer,
    cmsLoginReducer,
    cmsMyAccountModalsReducer,
    cmsMyAccountReducer,
    cmsnonXfinityCustomerReducer,
    cmsOneTimePaymentReducer,
    cmsOrderDetailReducer,
    cmsPlanSwitchReducer,
    cmsQuickpayBreadcrumbsReducer,
    cmsQuickpayErrorsReducer,
    cmsRetryPaymentReducer,
    cmsReturnOrderReducer,
    cmsRoleBasedCustomerReducer,
    cmsSettingsReducer,
    cmsSimSwapReducer,
    cmsStatementListReducer,
    cmsTradeInDeviceReducer,
    cmsTravelRatesReducer,
    cmsUsageDetailReducer,
    cmsUserQuickpayReducer,
    cmsUserRolesReducer,
    cmsVideoResolutionReducer,
    cmsWatchesReducer,
    cmsXmbComingSoonReducer
} from './cms/reducer';
import { creditCardReducer } from './credit-card/reducer';
import { heroBannerReducer } from './hero-banner/reducer';
import { internationalRateReducer } from './international-rates/reducer';
import { hopInitReducer } from './hop/reducer';
import {
    accountPlanEligibilityReducer,
    activationsReducer,
    changeNotificationReducer,
    datasaverStatusReducer,
    deviceNetworkCompatibilityReducer,
    insuranceElibilityReducer,
    lineCollectionReducer,
    lineDeviceCollectionReducer,
    linePromotionsReducer,
    lineStatusCollectionReducer,
    lineTransferBySessionIdReducer,
    lineTransferReducer,
    pendingLineTransferReducer,
    planEligibilityReducer,
    profileLinesReducer,
    requestResultReducer,
    sendOTPReducer,
    sendPortOutPinReducer
} from './line/reducer';
import { lineBannerReducer } from './line-banner/reducer';
import { orderDetailReducer } from './order/reducer';
import { returnEligibilityReducer } from './return-eligibility/reducer';
import { cartReducer, navCartReducer } from './cart/reducer';
import { requestStatusReducer } from './request-status/reducer';
import { orderCollectionReducer, transactionCollectionReducer } from './transaction/reducer';
import { usageDetailReducer, usageSummaryReducer } from './usage/reducer';
// eslint-disable-next-line max-len
import { gtpSessionCollectionReducer, relatedStatementTransactionCollectionReducer, ssmEstimatedReducer, ssmHistoricalReducer, ssmHistoricalV2Reducer, ssmStatementListReducer, ssmStatementListV2Reducer, statementListReducer, statementPdfReducer, statementPdfV2Reducer, statementReducer } from './statement/reducer';

import {
    deviceReturnReducer,
    findMyDeviceStatusReducer,
    reasonCodesReducer,
    returnInfoReducer
} from './device-return/reducer';
import { userReducer } from './user/reducer';
import { lineEligibilityReducer, ndelEligibilityReducer } from './ndel/reducer';
import { accountSummaryReducer } from './account-summary/reducer';
import { levelMoveEligibilityReducer, levelMoveOrderReviewReducer } from './level-move/reducer';
import { byodEligibilityReducer, eligibilityByodReducer, eligibilityByodStatusReducer } from './byod/reducer';
import { pastDueReducer, retryPaymentDataReducer, retryPaymentResultReducer } from './past-due/reducer';
import { User } from './user/models';
import { addonsCollectionReducer } from './addons/reducer';
import { oneTimePaymentReducer, oneTimePaymentResultReducer } from './one-time-payment/reducer';
import { quickpaymentMdnLookupReducer, quickpaymentReducer, quickpaymentResultReducer } from './quickpayment/reducer';
import { additionalDevicePaymentReducer, additionalDevicePaymentResultReducer } from './additional-device-payment/reducer';
import { esimChangeReducer } from './esim-change/reducer';
import { tradeInOfferPromoReducer, tradeInReducer } from './trade-in/reducer';
import { videoResolutionReducer } from './video-resolution/reducer';
import { loggerReducer } from './logger/reducer';
import { discountPromotionReducer } from './promotions/discount-promotion/reducer';
import { 
    watchesActivationRequestReducer,
    watchesActivationStatusReducer,
    watchesAddressReducer, 
    watchesAddressValidationReducer, 
    watchesPairEligibilityReducer, 
    watchesPairEligibilityRequestIdReducer,
    watchesTmoAddressReducer
} from './watches/reducer';
import { deviceEsimTransferReducer } from './esim/reducer';
import {
    cmsNowCoreReducer,
    cmsNowDeviceDetailsReducer,
    cmsNowEsimReducer,
    cmsNowLinesReducer,
    cmsNowModalsReducer,
    cmsNowMoreOptionsReducer,
    cmsNowNumberLockReducer,
    cmsNowReturnExchangeReducer,
    cmsNowStepUpAuthReducer
} from './now-mobile/cms/reducer';
import { nowAccountBadgesReducer } from './now-mobile/summary/reducer';
import {
    nowBillingSummaryReducer, nowDeviceCollectionReducer, nowLineAutoPayReducer, nowLineBadgesReducer, nowLineDetailsReducer, nowPauseCancelPortReducer, nowPortOutAuthCheckReducer, nowPortOutChangeNotifyReducer, nowPortOutSendPinReducer
} from './now-mobile/line/reducer';
import { nowDataUsageReducer, nowMobileLandingReducer, nowXMUpgradeReducer } from './now-mobile/mobile-landing/reducer';
import { nowNotificationBannerCollectionReducer } from './now-mobile/notification-banner/reducer';
import { nowEsimActivationReducer, nowEsimActivationStatusReducer } from './now-mobile/esim-activation/reducer';
import { nowBuyFlowReducer } from './now-mobile/buy-flow/reducer';
import { nowUserReducer } from './now-mobile/user/reducer';
import { nowLineLockAuthCheckReducer, nowLineLockReducer } from './now-mobile/line-lock/reducer';
import { stepUpAuthLinkLockReducer, stepUpAuthPaymentInstrumentReducer, stepUpAuthPortOutReducer } from './step-up-auth/reducer';
import { mdnLineLockStatusReducer } from './line-lock/reducer';
import { BroadbandLabelReducer } from './broadband-label/reducer';
import { planEligibilityDetailsReducer, planSwitchOrderReviewReducer, targetPlanSwitchDetailsReducer } from './plan-eligibility/reducer';
import { billingBannerReducer } from './billing-banner/reducer';
import { addonsRequestStatusReducer, addRemoveAddonsReducer, globalTravelPassReducer } from './global-travel-pass/reducer';
import { lineRetentionReducer } from './icop/reducer';
import { e911AddressReducer, e911AddressStatusReducer, e911AddressValidationReducer, e911SaveAddressReducer } from './e911/reducer';
import { cbmlocationReducer } from './locations/reducer';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const reducers: ActionReducerMap<LocalDB, XmAction<any>> = {
    cmsCore: cmsCoreReducer,
    cmsABTest: cmsABTestReducer,
    cmsActivity: cmsActivityReducer,
    cmsBillingAdp: cmsBillingAdpReducer,
    cmsBillingLanding: cmsBillingLandingReducer,
    cmsBillingPayment: cmsBillingPaymentReducer,
    cmsBillingStatement: cmsBillingStatementReducer,
    cmsBillingExchangeInstruction: cmsBillingExchangeInstructionReducer,
    cmsUsageDetail: cmsUsageDetailReducer,
    cmsBillingCredit: cmsBillingCreditReducer,
    cmsOrderDetail: cmsOrderDetailReducer,
    cmsDeviceReturn: cmsDeviceReturnReducer,
    cmsDevices: cmsDevicesReducer,
    cmsDeviceUpgrade: cmsDeviceUpgradeReducer,
    cmsDeviceSuspend: cmsDeviceSuspendReducer,
    cmsDeviceCancel: cmsDeviceCancelReducer,
    cmsErrors: cmsErrorsReducer,
    cmsExchangeOrder: cmsExchangeOrderReducer,
    cmsInternational: cmsInternationalReducer,
    cmsUserQuickpay: cmsUserQuickpayReducer,
    cmsAgentQuickpay: cmsAgentQuickpayReducer,
    cmsQuickpayErrors: cmsQuickpayErrorsReducer,
    cmsQuickpayBreadcrumbs: cmsQuickpayBreadcrumbsReducer,
    cmsReturnOrder: cmsReturnOrderReducer,
    cmsActivation: cmsActivationReducer,
    cmsEsimActivation: cmsEsimActivationReducer,
    cmsLogin: cmsLoginReducer,
    cmsHop: cmsHopReducer,
    cmsXmbComingSoon: cmsXmbComingSoonReducer,
    cmsNonXfinityCustomer: cmsnonXfinityCustomerReducer,
    cmsRoleBasedCustomer: cmsRoleBasedCustomerReducer,
    cmsSettings: cmsSettingsReducer,
    cms5GPlanOverview: cms5GPlanOverviewReducer,
    cmsLevelMoveStart: cmsLevelMoveStartReducer,
    cmsLevelMoveEligibility: cmsLevelMoveEligibilityReducer,
    cmsLevelMoveInProgress: cmsLevelMoveInProgressReducer,
    cmsLevelMovePending: cmsLevelMovePendingReducer,
    cmsLevelMoveSuccess: cmsLevelMoveSuccessReducer,
    cmsUserRoles: cmsUserRolesReducer,
    cmsLevelMoveError: cmsLevelMoveErrorReducer,
    cmsMyAccount: cmsMyAccountReducer,
    cmsMyAccountModals: cmsMyAccountModalsReducer,
    cmsDataDetail: cmsDataDetailReducer,
    cmsAccountDataPlanCollection: cmsAccountDataPlanCollectionReducer,
    cmsLineDataPlanCollection: cmsLineDataPlanCollectionReducer,
    cmsPlanSwitch: cmsPlanSwitchReducer,
    cmsBucketSwitch: cmsBucketSwitchReducer,
    cmsAddonErrors: cmsAddonErrorsReducer,
    cmsAddonPlans: cmsAddonPlansReducer,
    cmsInternationalTravel: cmsInternationalTravelReducer,
    cmsTravelRates: cmsTravelRatesReducer,
    cmsInternationalCalling: cmsInternationalCallingReducer,
    cmsCallFromUS: cmsCallFromUSReducer,
    cmsAddonDetails: cmsAddonDetailsReducer,
    cmsDataSaver: cmsDataSaverReducer,
    cmsContactBar: cmsContactBarReducer,
    cmsOneTimePayment: cmsOneTimePaymentReducer,
    cmsStatementList: cmsStatementListReducer,
    cmsAdditionalDevicePayment: cmsAdditionalDevicePaymentReducer,
    cmsRetryPayment: cmsRetryPaymentReducer,
    cmsExtendedPromos: cmsExtendedPromosReducer,
    cmsSimSwap: cmsSimSwapReducer,
    user: userReducer,
    orderDetail: orderDetailReducer,
    addonsCollections: addonsCollectionReducer,
    cart: cartReducer,
    navCart: navCartReducer,
    lineCollection: lineCollectionReducer,
    lineStatusCollection: lineStatusCollectionReducer,
    planEligibility: planEligibilityReducer,
    datasaver: datasaverStatusReducer,
    lineDeviceCollection: lineDeviceCollectionReducer,
    requestResult: requestResultReducer,
    lineEligibility: lineEligibilityReducer,
    lineRetention: lineRetentionReducer,
    ndelEligibility: ndelEligibilityReducer,
    byodEligibility: byodEligibilityReducer,
    eligibilityByod: eligibilityByodReducer,
    eligibilityByodStatus: eligibilityByodStatusReducer,
    accountSummary: accountSummaryReducer,
    levelMoveEligibility: levelMoveEligibilityReducer,
    levelMoveOrderReview: levelMoveOrderReviewReducer,
    planSwitchOrderReview: planSwitchOrderReviewReducer,
    usageSummary: usageSummaryReducer,
    usageDetail: usageDetailReducer,
    transactionCollection: transactionCollectionReducer,
    orderCollection: orderCollectionReducer,
    heroBanner: heroBannerReducer,
    international: internationalRateReducer,
    lineBanner: lineBannerReducer,
    hopInit: hopInitReducer,
    statements: statementReducer,
    relatedStatementTransactionCollection: relatedStatementTransactionCollectionReducer,
    statementList: statementListReducer,
    ssmStatementList: ssmStatementListReducer,
    ssmStatementListV2: ssmStatementListV2Reducer,
    gtpSessionCollection: gtpSessionCollectionReducer,
    creditCard: creditCardReducer,
    paymentSummary: paymentSummaryReducer,
    returnEligibilityCollection: returnEligibilityReducer,
    requestStatus: requestStatusReducer,
    pastDue: pastDueReducer,
    retryPaymentData: retryPaymentDataReducer,
    retryPaymentResult: retryPaymentResultReducer,
    reasonCodes: reasonCodesReducer,
    returnInfo: returnInfoReducer,
    findMyDeviceStatus: findMyDeviceStatusReducer,
    deviceReturnEligible: deviceReturnReducer,
    accountPlanEligibility: accountPlanEligibilityReducer,
    oneTimePayment: oneTimePaymentReducer,
    quickpayment: quickpaymentReducer,
    quickpaymentMdnLookup: quickpaymentMdnLookupReducer,
    quickpaymentResult: quickpaymentResultReducer,
    oneTimePaymentResult: oneTimePaymentResultReducer,
    additionalDevicePayment: additionalDevicePaymentReducer,
    additionalDevicePaymentResult: additionalDevicePaymentResultReducer,
    linePromotions: linePromotionsReducer,
    deviceNetworkCompatibility: deviceNetworkCompatibilityReducer,
    cmsByodExchange: cmsByodExchangeReducer,
    cmsCountryCodingMapping: cmsCountryCodingMappingReducer,
    lineTransferCollection: lineTransferReducer,
    cmsLineTransfer: CmsLineTransferReducer,
    lineTransferBySessionId: lineTransferBySessionIdReducer,
    pendingLineTransferCollection: pendingLineTransferReducer,
    cmsEsimDownload: cmsDeviceEsimDownloadReducer,
    esimChange: esimChangeReducer,
    cmsOneTimePasscode: cmsDevicePasscodeReducer,
    cmsCompatibilityCheck: cmsCompatibilityCheckReducer,
    cmsTradeInDevice: cmsTradeInDeviceReducer,
    tradeInOffer: tradeInReducer,
    cmsVideoResolution: cmsVideoResolutionReducer,
    videoResolution: videoResolutionReducer,
    logger: loggerReducer,
    discountPromoCollection: discountPromotionReducer,
    cmsWatches: cmsWatchesReducer,
    watchesPairEligibilityRequestId: watchesPairEligibilityRequestIdReducer,
    watchesStandalonePairEligibilityRequestId: watchesPairEligibilityRequestIdReducer,
    watchesAddressValidation: watchesAddressValidationReducer,
    watchesAddress: watchesAddressReducer,
    watchesActivationRequest: watchesActivationRequestReducer,
    watchesPairEligibility: watchesPairEligibilityReducer,
    cmsEsim: CmsEsimReducer,
    deviceEsimTransfer: deviceEsimTransferReducer,
    cmsNowCore: cmsNowCoreReducer,
    cmsNowLines: cmsNowLinesReducer,
    cmsNowModals: cmsNowModalsReducer,
    cmsNowDeviceDetails: cmsNowDeviceDetailsReducer,
    cmsNowMoreOptions: cmsNowMoreOptionsReducer,
    cmsNowNumberLock: cmsNowNumberLockReducer,
    cmsNowStepUpAuth: cmsNowStepUpAuthReducer,
    cmsNowReturnExchange: cmsNowReturnExchangeReducer,
    cmsNowEsim: cmsNowEsimReducer,
    nowBillingSummary: nowBillingSummaryReducer,
    nowLineDetails: nowLineDetailsReducer,
    nowDeviceCollection: nowDeviceCollectionReducer,
    nowMobileLandingCollection: nowMobileLandingReducer,
    nowDataUsageCollection: nowDataUsageReducer,
    nowXMUpgrade: nowXMUpgradeReducer,
    nowNotificationBannerCollection: nowNotificationBannerCollectionReducer,
    nowLineBadgesCollection: nowLineBadgesReducer,
    nowAccountBadgesCollection: nowAccountBadgesReducer,
    nowEsimActivation: nowEsimActivationReducer,
    nowEsimActivationStatus: nowEsimActivationStatusReducer,
    nowPauseCancelPort: nowPauseCancelPortReducer,
    nowLineAutoPayCollection: nowLineAutoPayReducer,
    nowBuyFlow: nowBuyFlowReducer,
    nowLineLock: nowLineLockReducer,
    nowLineLockAuthCheck: nowLineLockAuthCheckReducer,
    nowUser: nowUserReducer,
    nowPortOutSendPin: nowPortOutSendPinReducer,
    nowPortOutChangeNotify: nowPortOutChangeNotifyReducer,
    nowPortOutAuthCheck: nowPortOutAuthCheckReducer,
    stepUpAuthLineLock: stepUpAuthLinkLockReducer,
    stepUpAuthPortOut: stepUpAuthPortOutReducer,
    lineLockStatus: mdnLineLockStatusReducer,
    changeNotificationResult: changeNotificationReducer,
    sendPortOutPin: sendPortOutPinReducer,
    sendOTP: sendOTPReducer,
    stepUpAuthPaymentInstrument: stepUpAuthPaymentInstrumentReducer,
    broadbandLabels: BroadbandLabelReducer,
    insuranceElibility: insuranceElibilityReducer,
    planEligibilityDetails: planEligibilityDetailsReducer,
    targetPlanSwitchDetails: targetPlanSwitchDetailsReducer,
    activations: activationsReducer,
    profileLines: profileLinesReducer,
    ssmEstimated: ssmEstimatedReducer,
    ssmHistorical: ssmHistoricalReducer,
    ssmHistoricalV2: ssmHistoricalV2Reducer,
    statementPdf: statementPdfReducer,
    statementV2Pdf: statementPdfV2Reducer,
    billingBanner: billingBannerReducer,
    globalTravelPass: globalTravelPassReducer,
    addRemoveAddons: addRemoveAddonsReducer,
    addonRequestStatus: addonsRequestStatusReducer,
    tradeInOfferPromo: tradeInOfferPromoReducer,
    cmsE911Address: cmsE911AddressReducer,
    e911AddressValidation: e911AddressValidationReducer,
    e911Address: e911AddressReducer,
    e911SaveAddress: e911SaveAddressReducer,
    e911AddressStatus: e911AddressStatusReducer,
    watchesActivationStatus: watchesActivationStatusReducer,
    saveTmoAddress: watchesTmoAddressReducer,
    cbmLocations: cbmlocationReducer
};

export const REDUCER_TOKEN: InjectionToken<ActionReducerMap<XmAction<any>>> = new InjectionToken<ActionReducerMap<XmAction<any>>>('reducers');

export function clearState(reducer: ActionReducer<LocalDB>): ActionReducer<LocalDB> {
    return (state: LocalDB, action: Action): LocalDB => {
        if (action.type === StoreAction.CLEAR_ON_SUBMIT) {
            Object.keys(state).forEach((key: string) => {
                if (key === 'user') {
                    if (state[key]) {
                        state[key] = new User({ account: state[key].account });
                    }
                } else if (key !== 'orderDetail' && key !== 'byodEligibility' && !key.startsWith('cms')) {
                    state[key] = undefined;
                }
            });
        }

        return reducer(state, action);
    };
}

export const metaReducers: MetaReducer<LocalDB>[] = [clearState];
/* eslint-enable @typescript-eslint/no-explicit-any */
